module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.7.6-134.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.7.6.md
// module id = 552
// module chunks = 241